import { SortableFilter }          from './../common/sortable-filter';
import { ProductModel } from '../product-dialog/product.model';

export class OrderSortableFilter extends SortableFilter {
    public vart: string;
    public dateId: string;
    public cycleUID: string;
    public kitchenName: string;
    public exportFunction: string;
    public product: AutoCompleteProductModel;
}

export class AutoCompleteProductModel {
    public vart: string;
    public description: string;
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/order-logistical/order-sortable-filter.ts